import { HistoryState } from 'core-framework/window/HistoryState';
import { href as getLocationHref } from 'core-framework/window/location';

export const getLocationHash = (windowArg = window) => windowArg.location.hash;

export const back = (windowArg = window) => windowArg.history.back();
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
export const state = (windowArg = window): HistoryState => windowArg.history.state;

export const pushState = (path?: string, historyState: HistoryState = state()) => {
    window.history.pushState(historyState, '', path);
};

export const replaceState = (path?: string, historyState: HistoryState = state()) => {
    window.history.replaceState(historyState, '', path);
};

export const pushHashToHistory = (targetHash: string, historyState: HistoryState = state()) => {
    const currentPath = getLocationHref();
    if (!currentPath.includes(targetHash)) {
        pushState(`${currentPath}#${targetHash}`, historyState);
    }
};

export const removeHashFromPath = (targetHash?: string, doc = document, windowArg = window): boolean => {
    // https://stackoverflow.com/questions/1397329/how-to-remove-the-hash-from-window-location-url-with-javascript-without-page-r
    if (!targetHash || targetHash === '#') {
        windowArg.history.replaceState(null, '', ' ');
        return false;
    }

    if (!windowArg.location.href.includes(targetHash)) {
        return false;
    }

    const hrefWithoutTargetHash = windowArg.location.href.replaceAll(targetHash, '');
    windowArg.history.replaceState(null, doc.title, hrefWithoutTargetHash);
    return true;
};

export const removeHashFromHistory = (inputHash?: string, shouldGoBack = false, doc = document, windowArg = window) => {
    const targetHash = inputHash && (inputHash.startsWith('#') ? inputHash : `#${inputHash}`).trim();
    const isHashReplaced = removeHashFromPath(targetHash, doc, windowArg);

    if (isHashReplaced && shouldGoBack) {
        back(windowArg);
    }
};
